module.exports = __webpack_public_path__ + "static/media/armeeair_logo.c01b18d6.png";